module.exports = __webpack_public_path__ + "static/media/zeta2.61cb24b1.jpg";